import { U21Alert, U21Modal } from 'app/shared/u21-ui/components';

import { FilterContext, SavedFilter } from 'app/modules/filters/models';
import { useDeleteSavedFilter } from 'app/modules/filters/queries/useDeleteSavedFilter';
import pluralize from 'pluralize';

interface Props {
  filterContext: FilterContext;
  onClose: () => void;
  onDeleted?: (savedFilter: SavedFilter) => void;
  open: boolean;
  savedFilter: SavedFilter;
}

export const DeleteSavedFilterModal = ({
  filterContext,
  onClose,
  onDeleted,
  open,
  savedFilter,
}: Props) => {
  const { isPending, mutateAsync: deleteSavedFilter } =
    useDeleteSavedFilter(filterContext);

  return (
    <U21Modal
      actionButtonProps={{
        children: 'Delete',
        color: 'error',
        loading: isPending,
      }}
      onAction={async () => {
        try {
          await deleteSavedFilter(savedFilter.id);
          onDeleted?.(savedFilter);
          onClose();
        } catch {}
      }}
      onClose={onClose}
      open={open}
      title="Delete Saved Filter"
    >
      <U21Alert color="warning">
        Are you sure you want to delete <strong>{savedFilter.title}</strong>?{' '}
        {savedFilter.shared_team_ids.length > 0 && (
          <>
            This filter is shared with{' '}
            {pluralize('team', savedFilter.shared_team_ids.length, true)}.
            Deleting it will remove it for all members.
          </>
        )}
      </U21Alert>
    </U21Modal>
  );
};
